import React from "react";

import { cn } from "@/lib/utils";

import { Command as CommandPrimitive } from "cmdk";

const CommandRoot = React.forwardRef<
  React.ElementRef<typeof CommandPrimitive>,
  React.ComponentPropsWithoutRef<typeof CommandPrimitive>
>(({ className, ...props }, ref) => (
  <CommandPrimitive
    ref={ref}
    className={cn(
      "relative w-full flex-col overflow-visible rounded-md border-transparent shadow-none bg-primary",
      className,
    )}
    vimBindings={false}
    loop
    {...props}
  />
));
CommandRoot.displayName = CommandPrimitive.displayName;
export { CommandRoot };
